import * as React from 'react';
import * as DatePicker from 'react-datepicker';
import * as Modal from 'react-modal';
import * as moment from 'moment';
import { FormComponentProps } from '../../form/Form';
import { Ticket } from '../../../../generated/protocol';

interface CreateTicketModalProps extends FormComponentProps {
    isOpen: boolean,
    onClose: () => {},
    onSave: (Ticket) => {}
}

interface CreateTicketModalState {
    ticket: Ticket
}

export class CreateTicketModal extends React.Component<CreateTicketModalProps, CreateTicketModalState> {
    static createTicketModalStyle = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    constructor() {
        super();

        this.state = {
            ticket: {
                nameId: '',
                name: '',
                description: '',
                image: 'https://assets.globalpoker.com/entries/entry_icon.png',
                allowMultiple: true,
                expirationDate: null,
                expirationInterval: null,
                expirationIntervalUnits: 'NONE',
            },
        };
    }

    extractDate(date) {
        if (date === null) {
            return null;
        }
        let value = (date as any).valueOf();

        const d = new Date();
        d.setTime(value);
        const dateOnly = {year: d.getFullYear(), month: d.getMonth(), day: d.getDate()}
        console.log('DATE = ', dateOnly);
        value = moment.tz(dateOnly, 'UTC').valueOf();

        return value;
    }

    updateExpirationDate(value: object) {
        const ticket: Ticket = this.state.ticket;
        ticket.expirationDate = this.extractDate(value);

        this.setState({ticket});
    }

    updateTicket(fieldName: string, event: any) {
        const ticket: Ticket = this.state.ticket;
        ticket[fieldName] = event.target.value;

        this.setState({ticket});
    }

    onSave() {
        this.props.onSave(Object.assign({}, this.state.ticket));
        this.props.onClose();
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                style={CreateTicketModal.createTicketModalStyle}
                contentLabel='Create New Ticket'
            >
                <div className='create-ticket-modal'>
                    <div className='title'>Create New Ticket</div>
                    <button className='close-button' onClick={(event) => {
                        event.preventDefault();
                        this.props.onClose();
                    }}><i className='fa  fa-window-close-o'/></button>
                    <div className='row'>
                        <label className='col-sm-4 control-label'>Name ID</label>
                        <input className='col-sm-8' type='text' value={this.state.ticket.nameId}
                               onChange={this.updateTicket.bind(this, 'nameId')}/>
                    </div>
                    <div className='row'>
                        <label className='col-sm-4 control-label'>Name</label>
                        <input className='col-sm-8' type='text' value={this.state.ticket.name}
                               onChange={this.updateTicket.bind(this, 'name')}/>
                    </div>
                    <div className='row'>
                        <label className='col-sm-4 control-label'>Description</label>
                        <input className='col-sm-8' type='text' value={this.state.ticket.description}
                               onChange={this.updateTicket.bind(this, 'description')}/>
                    </div>
                    <div className='row'>
                        <label className='col-sm-4 control-label'>Image URL</label>
                        <input className='col-sm-8' type='text' value={this.state.ticket.image}
                               onChange={this.updateTicket.bind(this, 'image')}/>
                    </div>
                    <div className='row'>
                        <label className='col-sm-4 control-label'>Allow Multiple</label>
                        <input className='col-sm-8' type='checkbox' defaultChecked={this.state.ticket.allowMultiple}
                               onChange={this.updateTicket.bind(this, 'allowMultiple')}/>
                        <span className='help-block m-b-none'>If un-checked, ticket will be awarded only once (even if player won it more than once)</span>
                    </div>
                    <div className='row'>
                        <label className='col-sm-4 control-label'>Expiration Date</label>
                        <div className='col-sm-8'>
                            <DatePicker
                                selected={this.state.ticket.expirationDate != null ? moment.tz(this.state.ticket.expirationDate, 'UTC') : null}
                                onChange={this.updateExpirationDate.bind(this)}/>
                        </div>
                    </div>
                    <div className='row'>
                        <label className='col-sm-4 control-label'>Expiration Period</label>
                        <input className='col-sm-4' type='text' value={'' + this.state.ticket.expirationInterval}
                               onChange={this.updateTicket.bind(this, 'expirationInterval')}/>
                        <select className='col-sm-4' value={this.state.ticket.expirationIntervalUnits}
                                onChange={this.updateTicket.bind(this, 'expirationIntervalUnits')}>
                            <option>NONE</option>
                            <option>HOUR</option>
                            <option>DAY</option>
                            <option>WEEK</option>
                        </select>
                    </div>
                    <button className='save-button' onClick={(event) => {
                        event.preventDefault();
                        this.onSave();
                    }}><i className='fa fa-save'/>Save
                    </button>
                    <div className='bottom'/>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/CreateTicketModal.tsx